export default "__VITE_ASSET__CcpxvJnl__"